<template>

  <v-select :label="label" v-model="val" :items="items" clearable="clearable"></v-select>

</template>

<script>

export default {
  name: 'TopActionTypeSearch',
  props: ['value', 'label'],
  data: () => ({
    items: [
      'week',
      'month',
      'year'
    ]
  }),
  computed: {
    val: {
      get () {
        return this.value || null
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/TopActionTypeSearch.vue